<template>
  <b-container class="bv-example-row">
    <b-card>
    <b-list-group>
      <b-list-group-item v-for="(value, key) in data" :key="key">{{ key }}: {{ value }}</b-list-group-item>
    </b-list-group>
    </b-card>
  </b-container>
</template>
<script>
  import http from "../http-common";
  export default {
    name: 'DashboardDetails',
    data() {
      return{
        data:{},
        employeename:this.$route.query.employee,
        purpose:this.$route.query.purpose,
        stackname:this.$route.query.stackname
      }},
    methods:{
      async getInfo(){
      await http
        .get("/getdashboardstackfullinfo", {params:{ employeename: this.employeename, purpose: this.purpose, stackname: this.stackname}})
        .then(response => {
          this.data=response.data
        })
        .catch(e => {
          console.log(e);
        });
      }
    },
    created(){
      this.getInfo();
    }
    }
  </script>